import { AddressSortByLabel } from '../constants/sort';
import { setPageDetails, pushEventInfo } from './analytics';

export const setPaginatedPageAnalytics = () => {
  const paginatedPage = {
    category: {
      primaryCategory: 'account',
      subCategory1: 'account>addresses',
      subCategory2: 'account>addresses>pagination',
    },
    pageInfo: {
      pageName: 'account>addresses>pagination',
      pageType: 'maml:address book',
    },
    error: [],
  };

  setPageDetails(paginatedPage);
};

export const setFirstPageAnalytics = () => {
  const page = {
    category: {
      primaryCategory: 'account',
      subCategory1: 'account>addresses',
      subCategory2: 'account>addresses',
    },
    pageInfo: {
      pageName: 'account>addresses',
      pageType: 'maml:address book',
    },
    error: [],
  };

  setPageDetails(page);
};

export const setSortAnalytics = (sortType: AddressSortByLabel) => {
  const event = {
    category: {
      primaryCategory: 'button submission',
    },
    eventInfo: {
      eventName: 'my account settings',
    },
    myAccount: {
      settings: `addresses: sort: ${sortType}`,
    },
  };

  pushEventInfo(event);
};

export const setAddPhoneLinkAnalytics = (isAddMode: boolean) => {
  const mode = isAddMode ? 'add' : 'edit';
  const event = {
    category: {
      primaryCategory: 'button submission',
    },
    eventInfo: {
      eventName: 'my account settings',
    },
    myAccount: {
      settings: `${mode} address: add another phone`,
    },
  };

  pushEventInfo(event);
};

export const setDeleteAddressAnalytics = () => {
  const event = {
    category: {
      primaryCategory: 'button submission',
    },
    eventInfo: {
      eventName: 'my account settings',
    },
    myAccount: {
      settings: 'addresses: delete address',
    },
  };

  pushEventInfo(event);
};

export const setAddEditAddressAnalytics = (
  isAddMode: boolean,
  isDefault: boolean,
) => {
  const mode = isAddMode ? 'add' : 'edit';
  const defaultChecked = isDefault ? ': default' : '';
  const event = {
    category: {
      primaryCategory: 'button submission',
    },
    eventInfo: {
      eventName: 'my account settings',
    },
    myAccount: {
      settings: `addresses: ${mode} address${defaultChecked}`,
    },
  };

  pushEventInfo(event);
};

export const setNewDefaultAnalytics = () => {
  const event = {
    category: {
      primaryCategory: 'button submission',
    },
    eventInfo: {
      eventName: 'my account settings',
    },
    myAccount: {
      settings: 'addresses: set as default',
    },
  };
  pushEventInfo(event);
};
